module.exports = __webpack_public_path__ + "img/ics_o_close_red.399a040e.svg";